import React from "react";
import { Link, Navigate, useLocation } from "react-router-dom";
import { Riple } from "react-loading-indicators";
import { useAdminSession } from "../../hooks/use-admin-session";
import { canAccessRoles } from "../../utils/adminSession";

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const location = useLocation();
  const token =
    typeof window !== "undefined" ? window.localStorage.getItem("token") : null;
  const { currentUser, isLoading } = useAdminSession();

  if (!token) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  if (isLoading && !currentUser) {
    return (
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center">
        <Riple color="#4D2C5E" size="medium" text="" textColor="" />
      </div>
    );
  }

  if (!canAccessRoles(currentUser, allowedRoles)) {
    return (
      <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center p-6">
        <div className="w-full max-w-xl rounded-3xl border border-orange-100 bg-white p-8 text-center shadow-sm">
          <div className="mx-auto mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-orange-50 text-3xl text-purple">
            403
          </div>
          <h1 className="text-2xl font-bold text-gray-900">Access denied</h1>
          <p className="mt-3 text-sm text-gray-600">
            Your current account does not have permission to open this module.
          </p>
          <Link
            to="/dash/home"
            className="mt-6 inline-flex rounded-xl bg-bgBlue px-5 py-3 text-sm font-semibold text-white transition hover:opacity-90"
          >
            Return to dashboard
          </Link>
        </div>
      </div>
    );
  }

  return children;
};

export default ProtectedRoute;
